// Tiny className combiner — joins truthy class strings. Avoids pulling in
// clsx/tailwind-merge for a one-liner; we never produce conflicting Tailwind
// utilities in the same call, so a plain join is sufficient.
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
